export default function mounted() {
    this.getPaymentMode();
    this.getJournalTypes();

    // this.getBanks();
}
